module.exports = __webpack_public_path__ + "img/1.771e33b4.jpg";